import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import axios from "axios";
import { TrendingUp, TrendingDown } from "lucide-react";
import { API } from "@/lib/assets";

const FALLBACK = [
  { symbol: "QQQ", name: "Invesco QQQ", price: 712.51, change: 0.18 },
  { symbol: "SPY", name: "S&P 500", price: 738.53, change: 0.12 },
  { symbol: "DIA", name: "Dow Jones", price: 496.48, change: 0.07 },
  { symbol: "NVDA", name: "NVIDIA", price: 184.23, change: 2.45 },
  { symbol: "AAPL", name: "Apple", price: 232.11, change: -0.42 },
  { symbol: "TSLA", name: "Tesla", price: 358.92, change: 1.87 },
  { symbol: "MSFT", name: "Microsoft", price: 441.05, change: 0.55 },
  { symbol: "AMZN", name: "Amazon", price: 218.74, change: -0.31 },
  { symbol: "GOOGL", name: "Alphabet", price: 197.43, change: 0.92 },
  { symbol: "META", name: "Meta", price: 612.18, change: 1.34 },
];

const TickerPill = ({ t }) => {
  const up = t.change >= 0;
  return (
    <div
      data-testid={`ticker-${t.symbol.toLowerCase()}`}
      className="mx-3 inline-flex items-center gap-3 rounded-2xl bg-white border border-slate-100 px-5 py-3 shadow-[0_4px_18px_rgb(0,0,0,0.04)]"
    >
      <span className="font-display font-black text-slate-900">{t.symbol}</span>
      <span className="text-slate-500 text-sm hidden md:inline">{t.name}</span>
      <span className="font-display font-black text-slate-900">
        ${t.price.toFixed(2)}
      </span>
      <span
        className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-bold ${
          up ? "bg-[#D1FAE5] text-[#065F46]" : "bg-[#FEE2E2] text-[#991B1B]"
        }`}
      >
        {up ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
        {up ? "+" : ""}
        {t.change.toFixed(2)}%
      </span>
    </div>
  );
};

const MarketMarquee = () => {
  const [tickers, setTickers] = useState(FALLBACK);

  useEffect(() => {
    let alive = true;
    axios
      .get(`${API}/market/preview`)
      .then((res) => {
        if (alive && res?.data?.tickers) setTickers(res.data.tickers);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return (
    <section
      data-testid="market-marquee"
      className="relative py-8 bg-gradient-to-r from-[#FAFAFA] via-white to-[#FAFAFA] border-y border-slate-100"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 mb-4 flex items-center justify-between">
        <div className="inline-flex items-center gap-2">
          <span className="relative flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-60" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500" />
          </span>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
            Live Market
          </span>
        </div>
        <span className="text-xs text-slate-400 font-semibold">
          Real-time mock data · For learning
        </span>
      </div>
      <Marquee gradient={false} speed={45} pauseOnHover>
        {tickers.map((t) => (
          <TickerPill key={t.symbol} t={t} />
        ))}
      </Marquee>
    </section>
  );
};

export default MarketMarquee;
